import { render, staticRenderFns } from "./TaskViewFeaturePreview.vue?vue&type=template&id=67f5a75e&scoped=true&"
import script from "./TaskViewFeaturePreview.vue?vue&type=script&lang=js&"
export * from "./TaskViewFeaturePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5a75e",
  null
  
)

export default component.exports